<template>
    <div>
        <v-card elevation="0">
            <!--
            <v-row>
                <v-col md="6">
                    <UploadFile />
                </v-col>
                <v-col md="6">
                    <Download />
                </v-col>
            </v-row>
            -->
            <v-card-text>
                <v-container style="height: 450px;">
                    <v-row
                        class="fill-height"
                        align-content="center"
                        justify="center"
                    >
                        <v-col cols="auto" class="text-center">
                            <v-img src="../../../assets/backgrounds/tools-custom.png"></v-img>
                        </v-col>
                        <v-col cols="12" class="text-subtitle-1 text-center">
                            <v-card elevation="0">
                                <span>
                                    Under Construction
                                </span><br />
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import UploadFile from "./UploadFile.vue"
import Download from "./Download.vue"

export default {
    components: {
        UploadFile,
        Download
    }
    
}
</script>